var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('lodash'),
  pickBy = _require.pickBy;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate formOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const formTypeIdentifiers = await sourceEvaluator(source.formTypeIdentifiers);
  if (formTypeIdentifiers === undefined) {
    return undefined;
  }
  const filters = await sourceEvaluator(source.filters);
  const hasChildren = await sourceEvaluator(source.hasChildren);
  const sort = (await sourceEvaluator(source.sort)) || [{
    index: 'title',
    ascending: true
  }];
  const indexes = (await sourceEvaluator(source.indexes)) || [];
  const querySource = {
    type: 'queryFormBehavior',
    formTypeIdentifiers,
    indexes: ['title'].concat(indexes),
    sort,
    filters
  };
  const forms = await sourceEvaluator(querySource);
  if (forms === undefined) {
    return undefined;
  }
  const _transientContext$pag = transientContext.paging,
    _transientContext$pag2 = _transientContext$pag === void 0 ? {} : _transientContext$pag,
    _transientContext$pag3 = _transientContext$pag2.offset,
    offset = _transientContext$pag3 === void 0 ? 0 : _transientContext$pag3;
  const options = {};
  forms.forEach((form, index) => {
    const id = form.id,
      map = form.map;
    const title = map.title;
    const other = pickBy(map, (value, key) => indexes.includes(key));
    const value = _objectSpread(_objectSpread({}, other), {}, {
      title,
      _formRef: id,
      _created: offset + index + 1
    });
    if (hasChildren !== undefined) {
      value.hasChildren = hasChildren;
    }
    options[id] = value;
  });
  return {
    options,
    keep: ['_formRef']
  };
};
module.exports = {
  evaluate
};